import type { Theme } from './types'

export const lemonade: Theme = {
  name: 'Lemonade',
  isDark: false,
  font: "'DM Sans', -apple-system, sans-serif",
  colors: {
    bg: '#ffffff',
    bgSubtle: '#fafafa',
    text: '#1a1a1a',
    textSecondary: '#666666',
    textTertiary: '#999999',
    accent: '#3A6C3D',
    accentHover: '#2f5631',
    accentSoft: 'rgba(58, 108, 61, 0.08)',
    accentText: '#ffffff',
    border: '#e6e6e6',
    userBubble: '#f0f0f0',
    progressBg: '#e6e6e6',
    wrapperBg: '#f5f5f5',
    disabledBg: '#d1d5db',
    disabledText: '#ffffff',
    inputBg: '#ffffff',
  },
  radiusSm: '6px',
  radiusMd: '12px',
  radiusLg: '16px',
  radiusXl: '20px',
  shadow: '0 2px 8px rgba(0,0,0,0.06)',
  buttonStyle: 'rounded',
}
